import Vue from 'vue'
import Router from 'vue-router'
import vSelect from 'vue-select'
import SocialSharing from 'vue-social-sharing'
import Meta from 'vue-meta'
import 'vue-awesome/icons/facebook'
import 'vue-awesome/icons/whatsapp'
import Icon from 'vue-awesome/components/Icon'

Vue.component('icon', Icon)

Vue.use(Meta)
Vue.use(SocialSharing)

// autocomplete
Vue.component('v-select', vSelect)

// router
Vue.use(Router)

import utils from "@/utils/utils.js";

import routes from "./routes";

export default new Router({
  mode: 'history',
  // scrollBehavior () { // scrolls to top if a route has changed
  //   return { x: 0, y: 0 };
  // },
  base: (utils.isParentApp() ? 'parent/' : 'reader/'),
  linkActiveClass: 'is-active',
  routes: utils.isParentApp() ? routes.parentRoutes : routes.defaultRoutes
});
